import {MechanicValidatorLongestRoad} from '@colonist/game-mechanic-validators'
import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {useMapValidator} from './useMapValidator'
import {usePlayerValidators} from './usePlayerValidators'

export const useMechanicValidatorLongestRoad = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const mechanicLongestRoadState = useGameStore((state) => state.gameState.mechanicLongestRoadState)

    return useMemo(() => {
        if(!mechanicLongestRoadState) return undefined
        return new MechanicValidatorLongestRoad(playerValidators, mapValidator, mechanicLongestRoadState)
    }, [playerValidators, mapValidator, mechanicLongestRoadState])
}
